// test125
(125 && 0);
